// extracted by mini-css-extract-plugin
export var calculatedBadge = "_xf-8";
export var container = "_xf-0";
export var radioDot = "_xf-5";
export var radioDotSelected = "_xf-6";
export var row = "_xf-1";
export var rowFirst = "_xf-2";
export var rowLast = "_xf-3";
export var rowSelected = "_xf-4";
export var strikethrough = "_xf-7";